module.exports = __webpack_public_path__ + "static/media/internal_env_1_media_7.9989dad5.webp";